import * as Sentry from '@sentry/react'
import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import reloadOnChunkError from './app/reloadOnChunkError.ts'

const App = lazy(() =>
  window.location.pathname.startsWith('/shared/shortlist/')
    ? import('./app/PublicShortlistApp.tsx')
    : import('./app/App.tsx'),
)

reloadOnChunkError()

ReactDOM.createRoot(document.getElementById('root')!, {
  onCaughtError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <Suspense fallback={<div role="status">Loading…</div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
)
